import { Component, OnInit } from '@angular/core';
import { FlashMessage, MessageLevel } from '../flash.message.record';
import { FlashMessagesService } from '../service/flash.messages.service';
import { Observable, interval, } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    selector: 'on-flash-messages',
    templateUrl: './flash-messages.component.html'
})
export class FlashMessagesComponent implements OnInit {
    messages: FlashMessage[] = [];

    constructor(private flashMessagesService: FlashMessagesService) {

    }

    ngOnInit() {
        this.flashMessagesService.messages.subscribe(newMessage => {
            this.show(newMessage);
        });
        console.log('is load this msg componnet');
    }

    show(newMessage: FlashMessage): void {
        this.messages.push(newMessage);
        this.timerClose(newMessage);
    }

    closeMessage(message: FlashMessage) {
      this.remove(message);
    }

    showClose(message: FlashMessage): boolean {
      return !message.autoClose;
    }

    get alertTimer(): number {
        return 3500;
    }

    private timerClose(message: FlashMessage) {
        if (message.autoClose) {
          /**
           * take(1) ensures that interval(this.alertTimer) only happens once and then cleans up the observable.
           * Otherwise, the selenium tests will timeout waiting for the flashMessage interval to resolve.
           */
          interval(this.alertTimer).pipe(take(1)).subscribe(() => {
            this.remove(message);
          });
        }
      }

      findClass(message: FlashMessage): string {
        let messageCssClass: string;
        switch (message.level) {
          case MessageLevel.ERROR:
            messageCssClass = 'alert-danger';
            break;
          case MessageLevel.SUCCESS:
            messageCssClass = 'alert-success';
            break;
          case MessageLevel.WARN:
            messageCssClass = 'alert-warning';
            break;
          default: {
            messageCssClass = 'alert-info';
          }
        }
        return messageCssClass;
      }

      private remove(message: FlashMessage) {
        this.messages = this.messages.filter((value, key) => value.id !== message.id);
      }
}
